import { GoogleMapAddress } from '../../types/util';

export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const DEFAULT_ADDRESS: GoogleMapAddress = {
  location: 'Computalaya Networks, Pvt. Ltd',
  lat: 27.6546844,
  lng: 85.3478717,
};
